import { h } from 'vue';

// Mixinx
import { props, computed, methods } from './mixin';

export default {

    mixins: [props, computed, methods],

    render()
    {
        return h(
            'div',

            {
                class: [
                    'vh-chips',
                ],
            },

            [
                h(
                    'span',

                    this.label,
                ),
                
                h(
                    'a',
                    {
                        class: [
                            'vh-link-reset',
                            'vh-point',
                        ],

                        onClick: () => this.onClick,
                    },

                    [
                        h(
                            'i',

                            {
                                class: [
                                    'vh-chips-close',
                                    'fa fa-times',
                                ],
                            },
                        ),
                    ],
                ),
            ],

        );
    },
};
